import { createSelector } from 'reselect';
import { getSelectedAsset } from './assets';

const getSelectedFeeId = state => state.selectedFee;

export const getFees = createSelector(
    getSelectedAsset,
    asset => asset.access_fees || []
);

export const getSelectedFee = createSelector(
    [getFees, getSelectedFeeId],
    (fees, selectedFee) => fees.find(fee => fee.id === selectedFee) || {}
);



// WEBPACK FOOTER //
// ./src/selectors/accessFees.js